module.exports = __webpack_public_path__ + "img/listochki.2ab4da71.png";